var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ErrorBoundary } from 'react-error-boundary';
import { cbrConfig } from '../../helpers';
import CBRContext from './context';
import CreditBalanceRefundCard from './credit-balance-refund-card';
import i18n from '../../strings/i18n';
import { analyticsValues, triggerAnalyticsKeys } from '../../const/analytics';
import RefundError from './error';
import { CardContent, CardMain, CardWrapper } from './subcomponents';
import '../../const/initiate-icon-library';
var CreditBalanceRefund = function (_a) {
    var _b = _a.config, config = _b === void 0 ? cbrConfig : _b, accountId = _a.accountId, backToAccountManagerHandler = _a.backToAccountManagerHandler, triggerAnalyticsEvent = _a.triggerAnalyticsEvent, authenticationRedirect = _a.authenticationRedirect, handleProfileClick = _a.handleProfileClick;
    var value = useMemo(function () {
        return {
            accountId: accountId,
            backToAccountManagerHandler: backToAccountManagerHandler,
            config: config,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            handleProfileClick: handleProfileClick
        };
    }, [
        accountId,
        backToAccountManagerHandler,
        config,
        triggerAnalyticsEvent,
        handleProfileClick
    ]);
    var languageInStorage = localStorage.getItem('language');
    useEffect(function () {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(function (error) { return error; });
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    useEffect(function () {
        var _a;
        if (accountId) {
            triggerAnalyticsEvent((_a = {},
                _a[triggerAnalyticsKeys.pageKind] = analyticsValues.cbr,
                _a[triggerAnalyticsKeys.pageFunction] = analyticsValues.manageCreditBalance,
                _a[triggerAnalyticsKeys.pageName] = analyticsValues.view,
                _a));
        }
    }, [accountId, triggerAnalyticsEvent]);
    return (_jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(CBRContext.Provider, __assign({ value: value }, { children: _jsx(ErrorBoundary, __assign({ fallback: _jsx(CardWrapper, { children: _jsx(CardMain, { children: _jsx(CardContent, { children: _jsx(RefundError, {}) }) }) }) }, { children: _jsx(CreditBalanceRefundCard, { authenticationRedirect: authenticationRedirect }) })) })) })));
};
export default CreditBalanceRefund;
